import React from 'react';
import './ContactHero.css';

const ContactHero = () => {
  
  const heroStyle = {
    backgroundImage: 'url(/images/contact.jpg)', 
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '60vh', 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#fff',
    position: 'relative',
  };

  return (
    <div className="contact-hero" style={heroStyle}>
      
    </div>
  );
}

export default ContactHero;
